import { render, staticRenderFns } from "./Eingabe.vue?vue&type=template&id=20c85011&scoped=true"
import script from "./Eingabe.vue?vue&type=script&lang=js"
export * from "./Eingabe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c85011",
  null
  
)

export default component.exports